import { useState } from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, ChevronDown, Sparkles } from 'lucide-react';

const SEO_PAGES = [
  { href: '/photobooth-tunisie', label: 'Photobooth en Tunisie' },
  { href: '/photographe-mariage-djerba', label: 'Photographe mariage Djerba' },
  { href: '/photographe-evenement-tunis', label: 'Photographe événement Tunis' },
];

const SERVICES = [
  'Photographe & vidéaste mariage',
  'Location photobooth',
  'Production vidéo corporate',
  'Shooting studio & packshot',
];

export function HomeSeoSection() {
  const [expanded, setExpanded] = useState(false);

  return (
    <section className="relative overflow-hidden border-y border-gray-100 bg-white py-24">
      <div className="pointer-events-none absolute inset-0">
        <div className="absolute -right-32 top-0 h-96 w-96 rounded-full bg-primary-50 blur-3xl" />
        <div className="absolute -left-32 bottom-0 h-80 w-80 rounded-full bg-indigo-50 blur-3xl" />
      </div>

      <div className="relative z-10 mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="grid items-start gap-12 lg:grid-cols-2 lg:gap-16">
          <div>
            <span className="mb-4 inline-flex items-center gap-2 rounded-full bg-primary-500/10 px-4 py-1.5 text-[10px] font-black uppercase tracking-[0.25em] text-primary-600">
              <Sparkles className="h-3.5 w-3.5" />
              Studio depuis 1988
            </span>
            <h2 className="text-3xl font-black tracking-tighter text-gray-950 md:text-4xl">
              Studio photo &amp; production événementielle
            </h2>
            <p className="mt-5 text-lg leading-relaxed text-gray-600">
              <strong>Lbenna Prod</strong> réunit sous un même toit le reportage mariage, la vidéo corporate,
              le photobooth et la production audiovisuelle premium en Tunisie.
            </p>

            <div
              className={`mt-6 space-y-4 overflow-hidden text-base leading-relaxed text-gray-600 transition-all duration-500 ${
                expanded ? 'max-h-[800px] opacity-100' : 'max-h-0 opacity-0 lg:max-h-none lg:opacity-100'
              }`}
            >
              <p>
                Depuis 1988, nous accompagnons couples, entreprises et wedding planners avec une approche artisanale :
                préparation rigoureuse, matériel 4K et drone, retouche exigeante et production professionnelle pour des
                souvenirs qui durent. Qu&apos;il s&apos;agisse d&apos;un mariage destination, un gala au Lac ou un shooting
                packshot en studio, un interlocuteur unique vous guide du devis à la livraison finale.
              </p>
              <p>
                Notre force : une maîtrise complète de la chaîne de production audiovisuelle. Chaque projet 
                bénéficie d&apos;une post-production de haute précision, garantissant une esthétique 
                haut de gamme et cohérente avec l&apos;identité Lbenna Prod.
              </p>
            </div>

            <button
              type="button"
              onClick={() => setExpanded(!expanded)}
              className="mt-4 inline-flex items-center gap-2 text-sm font-bold text-primary-600 transition hover:text-primary-500 lg:hidden"
              aria-expanded={expanded}
            >
              {expanded ? 'Réduire' : 'En savoir plus'}
              <ChevronDown className={`h-4 w-4 transition-transform ${expanded ? 'rotate-180' : ''}`} />
            </button>
          </div>

          <div className="space-y-6">
            <div className="rounded-[2rem] border border-gray-100 bg-gray-50 p-6 md:p-8">
              <h3 className="mb-4 text-sm font-black uppercase tracking-[0.2em] text-gray-400">Nos prestations</h3>
              <ul className="space-y-3">
                {SERVICES.map((item) => (
                  <li key={item} className="flex items-start gap-3 text-sm font-semibold text-gray-800">
                    <span className="mt-1.5 h-1.5 w-1.5 shrink-0 rounded-full bg-primary-500" />
                    {item}
                  </li>
                ))}
              </ul>
            </div>

            <div className="rounded-[2rem] border border-primary-100 bg-primary-50/50 p-6 md:p-8">
              <h3 className="mb-4 text-sm font-black uppercase tracking-[0.2em] text-primary-600">Pages services</h3>
              <div className="flex flex-wrap gap-2">
                {SEO_PAGES.map((page) => (
                  <Link
                    key={page.href}
                    to={page.href}
                    className="rounded-full border border-primary-200 bg-white px-4 py-2 text-xs font-bold text-gray-800 transition hover:border-primary-400 hover:text-primary-600"
                  >
                    {page.label}
                  </Link>
                ))}
              </div>
              <Link
                to="/contact"
                className="mt-5 inline-flex items-center gap-2 text-sm font-black text-primary-600 transition hover:text-primary-500"
              >
                Demander un devis gratuit
                <ArrowRight className="h-4 w-4" />
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
